import './ClientQuotesCardSkeleton.scss';

const SKELETON_ROWS = 2;

const ClientQuotesCardSkeleton = () => (
  <div className="client-quotes-card-skeleton" aria-hidden="true">
    {Array.from({ length: SKELETON_ROWS }, (_, index) => (
      <div key={index} className="client-quotes-card-skeleton__row">
        <div className="client-quotes-card-skeleton__info">
          <span className="client-quotes-card-skeleton__bar client-quotes-card-skeleton__bar--name" />
          <span className="client-quotes-card-skeleton__bar client-quotes-card-skeleton__bar--segment" />
        </div>
        <span className="client-quotes-card-skeleton__bar client-quotes-card-skeleton__bar--action" />
      </div>
    ))}
  </div>
);

export default ClientQuotesCardSkeleton;
